import { useEffect, useState } from 'react';

export const SCROLL_UP = 'UP';
export const SCROLL_DOWN = 'DOWN';

const useScrollDirection = ({ initialDirection = SCROLL_DOWN, thresholdPixels = 64 } = {}) => {
    const [scrollDir, setScrollDir] = useState(initialDirection);
    const [scrollPosY, setScrollPosY] = useState(0);
    useEffect(
        () => {
            const threshold = thresholdPixels || 0;
            let lastScrollY = window.pageYOffset;
            let ticking = false;

            const updateScrollDir = () => {
                setScrollPosY(window.pageYOffset);
                const scrollY = window.pageYOffset;

                if (Math.abs(scrollY - lastScrollY) < threshold) {
                    ticking = false;
                    return;
                }

                setScrollDir(scrollY > lastScrollY ? SCROLL_DOWN : SCROLL_UP);
                lastScrollY = scrollY > 0 ? scrollY : 0;
                ticking = false;
            };

            const onScroll = () => {
                if (!ticking) {
                    window.requestAnimationFrame(updateScrollDir);
                    ticking = true;
                }
            };

            window.addEventListener('scroll', onScroll);

            return () => window.removeEventListener('scroll', onScroll);
        },
        [initialDirection, thresholdPixels],
    );

    return [scrollDir,scrollPosY];
};

export default useScrollDirection;
